function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoSmall = function SvgLogoSmall(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1280 800",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M582.9 337.5V5.4c0-2.8-2.3-5.4-5.4-5.4h-80.4c-2.8 0-5.6 2.3-6.2 5.1-13 113.4-123.3 223.5-245.5 245.8-2.8.6-5.1 3.4-5.1 6.2v80.4c0 2.8 2.3 5.1 5.1 5.1h332.1c2.5 0 5.4-2.3 5.4-5.1m0 456.9V714c0-2.8-2.3-5.6-5.1-6.2C464.6 694.5 354.6 584.4 332 461.9c-.6-2.8-3.4-5.1-6.2-5.1h-80.4c-2.8 0-5.1 2.3-5.1 5.4v332.1c0 2.8 2.3 5.4 5.1 5.4h332.1c2.5-.3 5.4-2.5 5.4-5.3m456.8-456.9V5.4c0-2.8-2.3-5.4-5.4-5.4H702.2c-2.8 0-5.4 2.3-5.4 5.4v80.4c0 2.8 2.3 5.6 5.1 6.2 122.8 22.6 223.2 123.3 245.8 245.8.6 2.8 3.4 5.1 6.2 5.1h80.4c2.9-.3 5.4-2.6 5.4-5.4m0 204.9V462c0-2.8-2.3-5.4-5.4-5.4H702.2c-2.8 0-5.4 2.3-5.4 5.4v332.1c0 2.8 2.3 5.4 5.4 5.4h80.4c2.8 0 5.6-2.3 6.2-5.1 22.6-122.8 123.3-223.2 245.8-245.8 2.9-.3 5.1-3.4 5.1-6.2",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ee751b"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoSmall);
export default ForwardRef;